const goalsPoints = { a: 0, b: 0, c: 1, d: 1, e: 3, f: 0, g: 0 };
const timePoints = { a: -2, b: 0, c: 2 };
class WeightModal extends HTMLElement {
    step;
    result;
    next;
    back;
    trigger;
    topTitle;
    topSteps;
    stepEl;
    toggle;
    time;
    weight;
    goals;
    constructor() {
        super();
        this.step = 1;
        this.result = this.querySelector('.product-modal_result_weight');
        this.next = this.querySelector('.product-modal_next');
        this.back = this.querySelector('.product-modal_back');
        this.trigger = document.querySelector('#trigger_product-modal');
        this.topTitle = this.querySelector('.product-modal_top_title');
        this.topSteps = this.querySelector('.product-modal_top_steps');
        this.stepEl = this.topSteps.querySelector('span');
        this.toggle = this.querySelector('.icon-cross');
        this.addEventListener('change', this.handleInput.bind(this));
        this.next.addEventListener('click', this.nextQuestion.bind(this));
        this.back.addEventListener('click', this.backQuestion.bind(this));
        if (location.hash === '#weight-picker' && this.trigger)
            this.trigger.click();
    }
    nextQuestion() {
        this.querySelector('[data-step="' + this.step + '"]').setAttribute('hidden', '');
        this.step = this.step + 1;
        this.querySelector('[data-step="' + this.step + '"]').removeAttribute('hidden');
        if (this.step < 4) {
            this.back.removeAttribute('hidden');
            if (this.querySelector('[data-step="' + this.step + '"] input:checked'))
                this.next.removeAttribute('hidden');
            else
                this.next.setAttribute('hidden', '');
            this.stepEl.innerHTML = '0' + this.step;
        }
        else {
            this.back.setAttribute('hidden', '');
            this.next.setAttribute('hidden', '');
            this.getResults();
        }
    }
    backQuestion() {
        this.next.removeAttribute('hidden');
        this.querySelector('[data-step="' + this.step + '"]').setAttribute('hidden', '');
        this.step = this.step - 1;
        this.querySelector('[data-step="' + this.step + '"]').removeAttribute('hidden');
        if (this.step === 1)
            this.back.setAttribute('hidden', '');
        this.stepEl.innerHTML = '0' + this.step;
    }
    getResults() {
        const timeP = timePoints[this.time];
        let goalsP = 0;
        this.goals.forEach(goal => {
            goalsP += goalsPoints[goal];
        });
        const goalsAndTime = goalsP + timeP < 4 ? "a" : "b";
        let res;
        if (this.weight === "10" || this.weight === "8" && goalsAndTime === "b")
            res = '10';
        else if (this.weight === "8" || this.weight === "6" && goalsAndTime === "b")
            res = '7';
        else if (this.weight === "6")
            res = '5';
        else if (this.weight === "f")
            res = '10';
        else if (this.weight === "a" || this.weight === "b" && goalsAndTime === "a")
            res = '15';
        else if (this.weight === "c" || this.weight === "b" && goalsAndTime === "b")
            res = '20';
        else
            res = '25';
        this.topSteps.setAttribute('hidden', '');
        this.topTitle.innerHTML = 'Result';
        if ('product' in window.theme && window.theme.product.title === 'Nappling') {
            if (res === '10') {
                this.result.setAttribute('hidden', '');
                this.result.nextElementSibling.removeAttribute('hidden');
            }
            else {
                this.result.nextElementSibling.setAttribute('hidden', '');
                this.result.innerHTML = '<span class="title">' + res + ' lbs</span><br>is the right weight for your child.';
                this.result.removeAttribute('hidden');
            }
        }
        else
            this.result.innerHTML = res + ' lbs';
        const input = document.querySelector('[name="Weight (lbs)"][value="' + res + '"]');
        if (input)
            input.click();
    }
    handleInput = (e) => {
        const { value, name } = e.target;
        this.next.removeAttribute('hidden');
        switch (name) {
            case 'time':
                this.time = value;
                break;
            case 'weight':
                this.weight = value;
                break;
            case 'goal':
                const inputs = this.querySelectorAll('[name="goal"]:checked');
                const arr = [];
                if (inputs) {
                    inputs.forEach(input => {
                        arr.push(input.value);
                    });
                }
                this.goals = arr;
                break;
        }
    };
}
customElements.define('weight-modal', WeightModal);
